import { createSelector } from '@reduxjs/toolkit';
import { VirtualListItem } from 'components/SectionedVirtualList';
import {
  selectAvailableUserIds,
  selectLocalUser,
  selectUserEntries,
} from 'features/users/usersSlice';
import { searchUsers } from 'features/users/utils/searchUsers';
import { sortUserAlphabetically } from 'features/users/sortUserAlphabetically';
import { getEntriesByIds } from 'utils/getEntriesByIds';

export type ContentLibraryUsersVirtualListItemType = VirtualListItem<'common'>;

export const selectContentLibraryActiveUsers = createSelector(
  [
    selectAvailableUserIds,
    selectUserEntries,
    selectLocalUser,
    (state, searchQuery: string) => searchQuery.toLowerCase(),
  ],
  (availableUserIds, userEntries, localUser, searchQuery) => {
    const result: ContentLibraryUsersVirtualListItemType[] = [];

    const activeUserEntries = getEntriesByIds(availableUserIds, userEntries);
    const searchedUsers = searchUsers(activeUserEntries, searchQuery);

    const searchedUsersArray = Object.values(searchedUsers);
    searchedUsersArray.sort(sortUserAlphabetically('firstName'));

    for (const user of searchedUsersArray) {
      if (user.id !== localUser?.id) {
        result.push({
          id: user.id,
          type: 'common',
          local: false,
          label: user.name as string,
          user,
        });
      }
    }

    return result;
  }
);
